export default {
  namespaced: true,
  name: 'SLSGfePrazoStore',
  state: () => ({
    gfePrazos: [],
    filters: {
      q: null,
      page: 1,
      perPage: 10,
      sortBy: null,
      sortDesc: null,
    },
  }),
  mutations: {
    setGfePrazos(state, payload) {
      state.gfePrazos = payload;
    },
    setFilters(state, payload) {
      state.filters = payload;
    },
    setPage(state, payload) {
      state.filters.page = payload;
    },
  },
  getters: {
    getGfePrazos(state) {
      return state.gfePrazos;
    },
    getFilters(state) {
      return state.filters;
    },
  },
};
